export const LINKS = {
  github: import.meta.env.VITE_GITHUB_URL || '',
  help: import.meta.env.VITE_HELP_URL || '',
};
